// Helper para construir URLs hacia la app Next (que vive en el mismo TLD via
// balanceador). Las cookies httpOnly que setea Next viajan automáticamente
// gracias al credentials: 'include' / withCredentials: true.
//
// Usamos REACT_APP_BASE_URL (el dominio público de la SPA: propilatam.com /
// propilatam.dev) porque el balanceador sirve ambas apps ahí. Si la env no
// está seteada, default vacío = same-origin.

const NEXT_BASE = (process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '')

export const nextAuthUrl = (country: string, path: string): string => {
  const clean = path.replace(/^\/+/, '')
  return `${NEXT_BASE}/${country}/api/auth/${clean}`
}

export const nextProxyBase = (country: string): string => {
  return `${NEXT_BASE}/${country}/api/proxy`
}

export const nextProxyUrl = (country: string, path: string): string => {
  const clean = path.replace(/^\/+/, '')
  return `${nextProxyBase(country)}/${clean}`
}
